import React from 'react';
import Face3DeviceList from '@/components/Face3DeviceList';

export default function Vision() {
  return <Face3DeviceList />;
}
